<template>
	<section class="hero">
		<div class="hero-body">
			<p class="title">Nothing to show here :(</p>
		</div>
	</section>
</template>

<script>
export default {
	name: 'EmptyHero',
};
</script>

<style scoped>
.hero {
	border: 2px solid #dddddd;
	border-radius: 10px;
	text-align: center;
	font-style: italic;
	box-shadow: rgba(255, 255, 255, 0.25) 0px 0px 10px 2px inset;
}
</style>
